import { useMutation, useQuery } from "@tanstack/react-query";
import { UsersAPI } from "../api";

export const useMyselfDetails = () => {
  return useMutation({
    mutationFn: () => UsersAPI.getMyselfDetails(),
    onError: (error) => {
      console.error("Get Myself Details Failed: ", error.response || error);
    },
  });
};

export const useGetAllEmployeesPaginated = () => {
  return useMutation({
    mutationFn: ({
      page,
      pageSize,
      filterField1 = null,
      filterValue1 = null,
      filterField2 = null,
      filterValue2 = null,
    }) => {
      const obj = {
        page,
        pageSize,
      };
      if (filterField1 && filterValue1) {
        obj.filterField1 = filterField1;
        obj.filterValue1 = filterValue1;
      }

      if (filterField2 && filterValue2) {
        obj.filterField2 = filterField2;
        obj.filterValue2 = filterValue2;
      }
      return UsersAPI.getAllPaginated(obj);
    },
    onError: (error) => {
      console.error("Get All Employees Failed: ", error.response || error);
    },
  });
};

export const useGetAllEmploymentStatuses = () => {
  return useMutation({
    mutationFn: () => UsersAPI.getAllEmploymentStatuses(),
    onError: (error) => {
      console.error(
        "Get All Employment StatusesFailed: ",
        error.response || error
      );
    },
  });
};

export const useCreateUser = () => {
  return useMutation({
    mutationFn: (userData) => UsersAPI.createUser(userData),
    onError: (error) => {
      console.error("Create User Failed: ", error.response || error);
    },
  });
};

export const useGetEmployeeById = () => {
  return useMutation({
    mutationFn: (id) => UsersAPI.getEmployeeById(id),
    onError: (error) => {
      console.error("Get User By ID Failed: ", error.response || error);
    },
  });
};

export const _useGetEmployeeById = (id) => {
  return useQuery({
    queryKey: ["get-employee-by-id", id],
    queryFn: () => UsersAPI.getEmployeeById(id),
    enabled: !!id,
    onError: (error) => {
      console.error("Get User By ID Failed: ", error.response || error);
    },
  });
};

export const useUpdateUser = () => {
  return useMutation({
    mutationFn: ({ id, userData }) => {
      console.log("userData: ", userData);
      return UsersAPI.updateUser(id, userData);
    },
    onError: (error) => {
      console.error("Update User Failed: ", error.response || error);
    },
  });
};

export const useGetAllJobPositions = () => {
  return useMutation({
    mutationFn: () => UsersAPI.getAllJobPositions(),
    onError: (error) => {
      console.error("Get All Job Positions Failed: ", error.response || error);
    },
  });
};

export const useGetAllJobGrades = () => {
  return useMutation({
    mutationFn: () => UsersAPI.getAllJobGrades(),
    onError: (error) => {
      console.error("Get All Job Grades Failed: ", error.response || error);
    },
  });
};
export const _useGetAllJobGrades = () => {
  return useQuery({
    queryKey: ["job-grades"],
    queryFn: () => UsersAPI.getAllJobGrades(),
    onError: (error) => {
      console.error("Get All Job Grades Failed: ", error.response || error);
    },
  });
};

export const useDeleteEmployee = () => {
  return useMutation({
    mutationFn: (id) => UsersAPI.deleteEmployee(id),
    onError: (error) => {
      console.error("Delete Employee Failed: ", error.response || error);
    },
  });
};
